export const TimeEffectEnum = Object.freeze({
    live: 0,
    morning:1,
    noon: 2,
    afternoon: 3,
    evening:4,
    none:5
})